export function isProd(): boolean {
  const host = window.location.hostname;
  return (
    host === "prod-atlas.sandvik.com" || host === "devxhub.scp.sandvik.com"
  );
}

export function productName(): string {
  const envProductName = import.meta.env.VITE_APP_NAME;
  if (envProductName && envProductName.trim() !== "") {
    return envProductName.trim().toLowerCase();
  }

  return window.location.hostname.includes("devxhub")
    ? "devxhub"
    : "prod-atlas";
}

export function isProdAtlasProduct(): boolean {
  return productName() === "prod-atlas";
}

export function appName(): string {
  return productName() === "devxhub" ? "DevXHub" : "ProdAtlas";
}

// The image is built once for all environments, so pick the DT UI by hostname.
export function dependencyTrackAppUrl(): string {
  const override = import.meta.env.VITE_DEPENDENCY_TRACK_APP_URL;
  if (override && override.trim() !== "") {
    return override.trim().replace(/\/$/, "");
  }
  return isProd()
    ? "https://dt5.scp.sandvik.com"
    : "https://dt5.dev.scp.sandvik.com";
}

export function dependencyTrackProjectUrl(projectUuid: string): string {
  return `${dependencyTrackAppUrl()}/projects/${encodeURIComponent(projectUuid)}`;
}
